import { useState, useEffect, Suspense } from "react"
import { object, func } from "prop-types"
import MakePaymentButton from "./MakePaymentButton"
import PaymentForm from "./PaymentForm"
import { useOrganization } from "source/registrations/hooks/useOrganization"
import { loadStripe } from "@stripe/stripe-js/pure"
import { Loading } from "source/shared/components"
import { AlertMessage } from "source/shared/components"

const PaymentFormWrapper = ({
  registration,
  registrationInvoice,
  onPaymentSave,
}) => {
  const [openForm, setOpenForm] = useState(false)
  const [stripe, setStripe] = useState(null)
  const [wrapperError, setWrapperError] = useState(null)

  if (!registrationInvoice.hasBalanceDue) return null

  const handleWrapperError = (error) => {
    setWrapperError(error)
  }

  const toggleForm = () => {
    setWrapperError(null)
    setOpenForm((prev) => !prev)
  }

  const {
    data: {
      paymentIntegration: { publishableKey, accountIdentifier },
    },
  } = useOrganization()
  const { allowCreditCardPayments, allowAchPayments, hasPaymentsModule } =
    registration.event

  useEffect(() => {
    const fetchStripe = async () => {
      const response = await loadStripe(publishableKey, {
        stripeAccount: accountIdentifier,
      })
      setStripe(response)
    }

    if (
      hasPaymentsModule &&
      (allowCreditCardPayments || allowAchPayments) &&
      publishableKey &&
      !stripe
    ) {
      fetchStripe()
    }
  }, [
    publishableKey,
    accountIdentifier,
    allowCreditCardPayments,
    allowAchPayments,
    hasPaymentsModule,
    stripe,
  ])

  if (!registrationInvoice.hasBalanceDue) return null

  return (
    <Suspense fallback={<Loading />}>
      {wrapperError && (
        <AlertMessage className="mt-2">
          <div style={{ color: "var(--color-ruby)" }}>
            {wrapperError.detail}
          </div>
        </AlertMessage>
      )}
      {!openForm && (
        <div className={"ta-c my-3"}>
          <MakePaymentButton
            balanceDueCents={registrationInvoice.balanceDueCents}
            registration={registration}
            onOpenForm={toggleForm}
          />
        </div>
      )}

      {openForm && (
        <PaymentForm
          registration={registration}
          registrationInvoice={registrationInvoice}
          onPaymentSave={onPaymentSave}
          onOpenForm={toggleForm}
          stripe={stripe}
          onWrapperError={handleWrapperError}
        />
      )}
    </Suspense>
  )
}

PaymentFormWrapper.propTypes = {
  registration: object.isRequired,
  registrationInvoice: object.isRequired,
  onPaymentSave: func.isRequired,
}

export default PaymentFormWrapper
